"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FallbackItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _productFallback = _interopRequireDefault(require("b2b-components/theme/assets/images/product-fallback.svg"));
var _Gallery = require("b2b-components/theme/components/Gallery");
var _Item = require("../Item");
var _ItemImage = require("../ItemImage");
var FallbackItem = function FallbackItem(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(_Item.Item, {
    type: _Gallery.GALLERY_ITEM_TYPE.fallback
  }, /*#__PURE__*/_react["default"].createElement(_ItemImage.ItemImage, {
    src: _productFallback["default"],
    title: title
  }));
};
exports.FallbackItem = FallbackItem;